export const name = 'styleUtilsService' as const
